import React from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { useAuth } from "../auth";
import { CreditCard, Calendar, AlertCircle } from "lucide-react";

export default function Subscription() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();

  const cancel = async () => {
    if (!window.confirm("Résilier votre abonnement ? Vous reviendrez sur le forfait Découverte.")) return;
    await api.post("/subscription/cancel");
    await refresh();
  };

  const planLabels = { decouverte: "Découverte (gratuit)", essentiel: "Essentiel", confort: "Confort" };
  const statusLabels = { active: "Actif", canceled: "Résilié", free: "Gratuit" };

  return (
    <div className="space-y-8">
      <div>
        <div style={{ color: "var(--auprea-gold)", fontSize: 12, letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 600, marginBottom: 12 }}>
          — Mon compte
        </div>
        <h1 style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }} data-testid="abonnement-title">Gérer mon abonnement</h1>
      </div>

      <div className="auprea-card space-y-6">
        <div className="flex items-center gap-4">
          <CreditCard size={32} color="#caa86a" />
          <div>
            <div style={{ fontSize: 13, color: "rgba(35,38,46,0.6)", textTransform: "uppercase", letterSpacing: "0.1em" }}>Forfait actuel</div>
            <div style={{ fontFamily: "Spectral, serif", fontSize: 28, color: "var(--auprea-navy)" }} data-testid="current-plan">{planLabels[user.plan_id] || user.plan_id}</div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 pt-4 border-t" style={{ borderColor: "rgba(21,41,79,0.1)" }}>
          <div>
            <div style={{ fontSize: 13, color: "rgba(35,38,46,0.6)", textTransform: "uppercase", letterSpacing: "0.1em" }}>Statut</div>
            <div style={{ fontSize: 17, marginTop: 4 }} data-testid="subscription-status">
              {statusLabels[user.subscription_status] || user.subscription_status}
            </div>
          </div>
          {user.current_period_end && (
            <div>
              <div style={{ fontSize: 13, color: "rgba(35,38,46,0.6)", textTransform: "uppercase", letterSpacing: "0.1em" }}>Prochaine échéance</div>
              <div style={{ fontSize: 17, marginTop: 4 }}>
                <Calendar size={14} style={{ display: "inline", marginRight: 6 }} />
                {new Date(user.current_period_end).toLocaleDateString("fr-FR")}
              </div>
            </div>
          )}
        </div>

        <div className="flex flex-wrap gap-4 pt-4 border-t" style={{ borderColor: "rgba(21,41,79,0.1)" }}>
          <button className="auprea-btn" onClick={() => nav("/tarifs")} data-testid="btn-change-plan">
            Changer de forfait
          </button>
          {user.plan_id !== "decouverte" && user.subscription_status === "active" && (
            <button className="auprea-btn-outline" onClick={cancel} style={{ borderColor: "#b53a3a", color: "#b53a3a" }} data-testid="btn-cancel-sub">
              <AlertCircle size={16} style={{ marginRight: 6 }} /> Résilier
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
